import React, { Component } from 'react';
import PropTypes from 'prop-types';

import {
  INCOME_VERIFICATION_PROVIDER_VERIFAST,
} from 'common/incomeVerificationConstants';

import {
  SR_API_ACTION_INCOME_VERIFICATION_CREATE_SCREENING,
} from 'api/actionTypes';

import branch from 'client/core/branch';
import postWithState from 'client/actions/postWithState';
import withLocationQuery from 'client/helpers/withLocationQuery';

import SrBox from 'client/components/SrBox';
import SrButton, {
  SR_BUTTON_THEME_ADOBE_YELLOW,
  SR_BUTTON_THEME_ADOBE_GREEN,
} from 'client/components/SrButton/SrButton';

@withLocationQuery
@branch({
  currentUserId: ['currentUser', 'id'],
  verifastApiUrl: ['env', 'VERIFAST_API_URL'],
})
class SrVerifastProofOfConceptPage extends Component {
  static getPageMetadata = () => ({
    pageTitle: 'Verifast POC | Sunroom Rentals',
  })

  static propTypes = {
    currentUserId: PropTypes.number.isRequired,
    verifastApiUrl: PropTypes.string.isRequired,
  }

  constructor(props) {
    super(props);
    this.state = {
      iframeUrl: null,
    };

    this.incomeVerificationIframeTopListener = null;
    this.incomeVerificationIframeListener = null;
    this.iframeRef = null;
  }

  componentDidMount() {
    this._setIframeListeners();
  }

  _setIframeListeners = () => {
    const { verifastApiUrl } = this.props;

    this.incomeVerificationIframeTopListener = global.top.addEventListener('message', (e) => {
      e.data.origin = e.origin;
      if (this.iframeRef) {
        this.iframeRef.contentWindow.postMessage(
          e.data,
          verifastApiUrl,
        );
      }
    });

    this.incomeVerificationIframeListener = global.addEventListener('message', (e) => {
      e.data.origin = e.origin;
      if (e.origin === verifastApiUrl && e.data?.detail === 'complete') {
        this._onIncomeVerificationCompleted();
      }
    });
  }

  _onStartIncomeVerificationClick = async () => {
    const {
      currentUserId,
      dispatch,
    } = this.props;

    const incomeVerificationUserId = currentUserId || 1821;

    const incomeVerificationGroup = await dispatch(postWithState, {
      action: SR_API_ACTION_INCOME_VERIFICATION_CREATE_SCREENING,
      payload: {
        userIds: [incomeVerificationUserId],
        listingId: 431123,
        provider: INCOME_VERIFICATION_PROVIDER_VERIFAST,
      },
    });

    const incomeVerification = incomeVerificationGroup.incomeVerifications.find(({ userId }) => {
      return userId === incomeVerificationUserId;
    });

    if (incomeVerification) {
      this.setState({
        iframeUrl: incomeVerification?.screeningUrl,
      });
    }
  }

  _onCloseIncomeVerificationModal = () => {
    this.setState({
      iframeUrl: null,
    });
  }

  _onIncomeVerificationCompleted = () => {
    this._onCloseIncomeVerificationModal();
    setTimeout(() => {
      global.alert('Income verification completed.');
    }, 500);
  }

  render() {
    const {
      locationQuery,
    } = this.props;

    const {
      iframeUrl,
    } = this.state;

    return (
      <div>
        {iframeUrl &&
          <SrBox position='relative'>
            <SrBox position='absolute' top='100px' left='100px'>
              <SrButton
                theme={SR_BUTTON_THEME_ADOBE_GREEN}
                onClick={this._onCloseIncomeVerificationModal}
              >
                Back to SR
              </SrButton>
            </SrBox>
            <SrBox width='100vw' height='100vh'>
              <iframe
                ref={(iframeRef) => {
                  this.iframeRef = iframeRef;
                }}
                allow='camera'
                title='Verifast'
                src={iframeUrl}
                style={{
                  width: '100%',
                  height: '100%',
                }}
              />
            </SrBox>
          </SrBox>
        }

        {!iframeUrl && !locationQuery.completed &&
          <SrButton
            theme={SR_BUTTON_THEME_ADOBE_YELLOW}
            onClick={this._onStartIncomeVerificationClick}
          >
            Start Income Verification
          </SrButton>
        }

        {locationQuery.completed &&
          <div>
            Thanks! Income verification completed.
          </div>
        }
      </div>
    );
  }
}

SrVerifastProofOfConceptPage.displayName = 'SrVerifastProofOfConceptPage';

export default SrVerifastProofOfConceptPage;
